"use strict";module.exports = {
  handleCollapse(_ref) {var originalEvent = _ref.originalEvent;
    if (this._expander.expanded) {
      this._expander.expanded = false;
      this.emit('collapse', { originalEvent });
    }
  },

  handleExpand(_ref2) {var originalEvent = _ref2.originalEvent;
    if (!this._expander.expanded) {
      this._expander.expanded = true;
      this.emit('expand', { originalEvent });
    }
  },

  onMount() {
    this._expander = this.getComponent('base')._expander;
    this._expander.expanded = true;
  } };